import { useEffect } from 'react';

const SITE_URL = 'https://plouton.co';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_conversion-v2/artifacts/me7o2pm6_Plouton-2-1.webp';

const usePageSEO = ({ title, description, path, image, type }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(name.startsWith('og:') || name.startsWith('twitter:') ? 'property' : 'name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setLink = (rel, href) => {
      if (!href) return;
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    // Basic meta
    if (description) setMeta('description', description);

    // Canonical
    const canonicalUrl = path ? `${SITE_URL}${path}` : SITE_URL;
    setLink('canonical', canonicalUrl);

    // Open Graph
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:url', canonicalUrl);
    setMeta('og:image', image || DEFAULT_IMAGE);
    setMeta('og:type', type || 'website');
    setMeta('og:site_name', 'Plouton AI');

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', image || DEFAULT_IMAGE);

    return () => {
      document.title = 'Experience No-Code Finance Automation With Plouton AI';
      setMeta('description', "Scale your daily tasks using our browser-based AI agents. Plouton AI's no-code financial automations manage your accounts payable and bank reconciliation.");
    };
  }, [title, description, path, image, type]);
};

export default usePageSEO;
